import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

//Import Store
import store from '../../../store';

//Import Action
// import { getPromoProductsHome } from '../../../action/promoProducts';
import { getHomepageProductsAction } from '../../../action/products';

//Import Custom Component
import ProductTypeCatalog from '../../features/product/product-type-catalog';
import ProductCardSkeleton from '../../features/product/product-card-skeleton';
import Carousel from '../../features/carousel';

//Import Settings
import { owlSettingProm } from '../../../utils/settings';

function PopularProducts ( props ) {
  // const { promoProductsHome } = props;
  const { productsHP } = props;

  // useEffect(() => {
  //   if (!promoProductsHome.length) {
  //     store.dispatch(getPromoProductsHome());
  //   }
  // }, []);

  useEffect(() => {
    if (!productsHP.length) {
      store.dispatch(getHomepageProductsAction());
    }
  }, []);

  return (
    <div className="container">
      <div className="section-title text-center">
        <h2 className="mb-2">{ props.title }</h2>
      </div>

      <div className="product-intro">
        <Carousel addClass="owl-dots-top carousel-with-shadow" settings={ owlSettingProm }>
          {
            productsHP.length
              ? productsHP.map( ( product, index ) => (
                <ProductTypeCatalog
                  addClass="inner-quickview inner-icon p-3"
                  product={ product }
                  type="left-detail"
                  key={ "ProductTypeProm" + index }
                />
              ))
              : [0, 1, 2, 3, 4, 5].map( ( index ) => (
                <ProductCardSkeleton key={ "hp-skel-" + index } count={1} className="inner-quickview inner-icon p-3" />
              ))
          }
        </Carousel>
      </div>
    </div>
  );
}

const mapStateToProps = ( state ) => {
  return {
    promoProductsHome: state.promoProducts.promoProductsHome ? state.promoProducts.promoProductsHome : [],
    productsHP: state.products.productsHP ? state.products.productsHP : [],
  }
}

export default connect(mapStateToProps)(PopularProducts);